import Countdown from "common/components/countdown/Countdown";
import initializeSvelteApp from "common/initializeSvelteApp";

initializeSvelteApp({
  component: Countdown,
  target: ".js-countdown",
  props: element => {
    return {
      value: element.getAttribute("data-duration")
        ? element.getAttribute("data-duration")
        : "0",
      color: element.getAttribute("data-color"),
    };
  },
});
